import $ from 'jquery'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import { debounce, getTextNodesIn } from '../functions'

imagesLoaded.makeJQueryPlugin($)


let faqIso = ''

const parent = $('.js-faq-iso')
if (parent.length != 0) {
    faqIso = new Isotope('.js-faq-iso', {
        itemSelector: '.js-faq-iso-item',
        transitionDuration: 0,
    })

    parent.imagesLoaded(function () {
        faqIso.layout()
    })

    $('.js-faq-iso-search').keyup( function () {
        arrangeFaqIso();
    })

    $('.js-faq-select').on('change', function () {
        arrangeFaqIso();
    })
}

function arrangeFaqIso () {
    faqIso.arrange({
        filter: function () {
            const posts = $(this)
            const vals = [$('.js-faq-select').val()]

            const attr = posts.attr('data-categories')
            const categories = attr.includes(',') ? attr.split(',') : [attr]
            const newCategories = categories.map(Number)
            let hasCategory = false

            if (vals[0] == null) {
                hasCategory = true
            }

            if (newCategories.length > 0) {
                for (let i = 0; i < vals.length; i++) {
                    if (
                        newCategories.includes(parseInt(vals[i])) ||
                        vals[i] === 'all'
                    ) {
                        hasCategory = true
                    }
                }
            }

            const qsRegex = new RegExp($('.js-faq-iso-search').val(), 'gi')
            const text = getTextNodesIn(posts[0])

            let hasText = qsRegex ? text.match(qsRegex) : true

            return hasCategory && hasText
        },
    })
}

document.addEventListener('DOMContentLoaded', function () {
    const accordions = document.querySelectorAll('.accordion-item');

    accordions.forEach((accordion) => {
        accordion.addEventListener('show.bs.collapse', function (event) {
            event.target.closest('.accordion-item').classList.add('open');
        });

        accordion.addEventListener('hide.bs.collapse', function (event) {
            event.target.closest('.accordion-item').classList.remove('open');
        });
    });
});